export default __webpack_public_path__ + "static/surgical_boom_w.861bae590c16f700ff33b361d24bd8db.png";